import { DashboardLayout } from '@/components/layout';
import { PendingTripsList } from '../components';

export function TripsPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-2xl font-bold text-secondary-900">Trips</h1>
          <p className="text-secondary-600 mt-1">
            Manage mileage trips and assign them to projects
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl border border-secondary-200 p-6">
          <PendingTripsList />
        </div>

        {/* Help Text */}
        <div className="bg-primary-50 border border-primary-200 rounded-lg p-4">
          <h3 className="text-sm font-medium text-primary-900 flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Trip Location Matching
          </h3>
          <p className="text-sm text-primary-700 mt-1">
            Trips are automatically matched to nearby project sites based on start and end locations.
            High confidence matches (within 50m) are shown first.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}